import api from './api';

interface UpdateUserRequest {
  nickname?: string;
  email?: string;
}

export const userService = {
  // 获取用户信息
  async getProfile(): Promise<any> {
    const response = await api.get('/users/profile');
    return response.data;
  },

  // 更新用户信息
  async updateProfile(data: UpdateUserRequest): Promise<any> {
    const response = await api.put('/users/profile', data);
    return response.data;
  },
};